//Core
import React from "react"

//Components
import Layout from "../../container/Layout"
import Pudra from "../../modules/pudra_new"

//Styles
// import "../../styles/main.scss"

const PudraPage = () => {
  return (
    <Layout
      title={`Оформи #PudraCard та отримай 50 грн`}
      description={`Ідеальна картка для шопінгу: одяг, взуття, косметика, парфумерія – високий кешбек для всіх твоїх бажань`}
      link={`https://tascombank.ua/promo/pudracard/`}
    >
      <Pudra></Pudra>
    </Layout>
  )
}

export default PudraPage
